import { setAutoFreeze } from "immer"
// turn off auto freezing (it's enabled by default) so `produce` is side effect free
setAutoFreeze(false)
